export enum ViewLayoutConfig {
    Default,
    DrawerOnly = 'drawer'
}
